import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import SafetyPortalApp from './SafetyPortalApp';
import { initializeSupabase } from './lib/supabase';
import './index.css';

// For deployment, we need to provide default Supabase credentials
// These should be replaced with actual values in production
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://your-project-ref.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'your-supabase-anon-key';

// Initialize Supabase before rendering the app
initializeSupabase(supabaseUrl, supabaseAnonKey);

// Always render the app for deployment
const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <SafetyPortalApp 
        supabaseUrl={supabaseUrl} 
        supabaseAnonKey={supabaseAnonKey}
      />
    </StrictMode>
  );
}

// Also export the component for use in other projects
export default SafetyPortalApp;